<template>
    <div>
        <div v-if="campaign != null">
            <div class="wrapper-img-campaign">
                <campaign-picture
                    :arrCampaignImage="campaign.pictures"
                ></campaign-picture>
            </div>

            <div class="wrapper-icon-back" @click="clickBack()" >
                <img class="icon-back" src="../../../assets/campaign/icon_back@2x.png" />
            </div>
            <div class="wrapper-detail">
                <div class="campaign-name">{{ campaign.name }}</div>
                <detail-and-condition
                    :lbl="lbl"
                    :campaign="campaign"
                ></detail-and-condition>
            </div>
            <!-- <div class="redeem-border"></div> -->
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Account from '@/helper/AccountHelper.js';
import CampaignPicture from "@/components/campaign/detail/PictureEven.vue";
import DetailAndCondition from "@/components/campaign/detail/DetailAndCondition";
import DatetimeHelper from "@/helper/DatetimeHelper.js";


/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {object} campaign (required) Campaign information.
 * Method
 * @method initialLayout Setup campaign information.
 * @method updateSelectedCampaignInfo Callback for subcampagin to update Campaign information.
 */
export default {
    name: "EventLayout",
    components: {
        CampaignPicture,
        DetailAndCondition,
    },
    props: {
        lbl: Object,
        locale: Number,
        campaign: Object
    },
    data: function() {
        return {
            campaignId: "",
            quantity: 0,
            point: 0,
            price: 0,
            originPrice: 0,
            discount: 0,
            qty: 0,
            expireDate: null,

            isShowSubcampaign: false,
            subCampaign: null
        };
    },
    created: function() {
        this.initialLayout();
        Account.loginStatus().then((status) => {
            this.isLogin = status;
        });
    },
    methods: {
        initialLayout: function() {
            if (this.campaign.subCampaignStyles) {
                this.isShowSubcampaign = true;
                this.subCampaign = this.campaign.subCampaignStyles.styles;

                var firstsubcampaign = this.campaign.subCampaignStyles
                    .styles[0];
                if (firstsubcampaign.subitems[0].value != "none")
                    firstsubcampaign = firstsubcampaign.subitems[0];

                this.updateSelectedCampaignInfo(firstsubcampaign);
            } else {
                this.updateSelectedCampaignInfo();
            }
        },
        updateCampaignInfo: function(campaign) {
            this.campaign.updateCampaign(campaign);
            this.initialLayout();
        },
        updateSelectedCampaignInfo: function(selectedItem) {
            if (selectedItem) {
                this.campaignId = selectedItem.campaignId;
                this.quantity =
                    selectedItem.quantity - (selectedItem.itemCountSold || 0);
                this.point = selectedItem.points || selectedItem.point || 0;
                this.price = selectedItem.price;
                this.originalPrice = selectedItem.originalPrice;
                this.discount = selectedItem.discount;
                this.qty = selectedItem.qty;
                this.expireDate = this.campaign.expireDate;
            } else {
                this.campaignId = this.campaign.id;
                this.quantity = this.campaign.qty;
                this.point = this.campaign.pointPerUnit;
                this.price = this.campaign.pricePerUnit;
                this.originalPrice = this.campaign.originalPrice;
                this.discount = this.campaign.discount;
                this.qty = this.campaign.qty;
                this.expireDate = this.campaign.expireDate;
            }
        },
        clickBack: function() {
            var path = "/";
            var CachecampaignID = Account.getCacheCustom('campaignId');

            var gtm = {
                 "event_label": "back_from_privilege_detail",
                 "timestamp": DatetimeHelper.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege", "click_buttons", gtm.event_label, null, gtm);

            if (this.$route.params.form == "history") {
                this.$router.push({ name: 'history'});
            } else if (!this.isLogin) {
                path = "/campaign/" + this.campaign.id + "?command=close";
                this.$router.push(path);
            } else if (CachecampaignID) {
                path = "/campaign/" + this.campaign.id + "?command=close";
                this.$router.push(path);
            } else {
                this.$router.push({ name: 'home'});
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
.wrapper-img-campaign {
    padding: 55px 25px 45px 25px;
    background-image: url('../../../assets/home/bg-home.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
}

.wrapper-icon-back {
    width: 13px;
    height: 35px;
    position: absolute;
    top: 15px;
    left: 20px;

    .icon-back {
        width: 100%;
    }
}

.wrapper-detail {
    padding: 30px 30px 65px 30px;
    background-color: white;
    border-radius: 30px 30px 0 0;
    margin-top: -30px;
    overflow: hidden;
    position: relative;
    min-height: calc(100vh - 250px);

    .campaign-name {
        color: $black-default;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 7px;
        font-size: 26px;
    }

    .campaign-expire-date {
        color: $black-default;
        font-size: 17px;
        line-height: 0.9em;
        margin-bottom: 15px;
    }

    .campaign-qty {
        font-weight: 500;
        font-size: 22px;
        line-height: 0.9em;
        color: $primery-color;
    }
}
.redeem-border {
    width: 40%;
    height: 8px;
    margin-top: -25px;
    background-color: $black-default;
    border-radius: 3px;
    margin-left: 30%;
    position: relative;
}
</style>
